export interface ILabelPreviewHtml {
  html: string;
  companionHtml?: string;
  widthMm: number;
  heightMm: number;
  companionWidthMm?: number;
  companionHeightMm?: number;
}
